import React from 'react';
import Modal from '../../../Modal';
import { ResetPassword } from '../../../Authorization';
import { bodyScrollFix } from '../../../../utils';

export default ({ onOk, visible, isLoading, data, ...rest }) => {
  return (
    <Modal
      title={null}
      open={visible}
      footer={null}
      width={'auto'}
      {...rest}
      wrapClassName="auth"
      afterClose={bodyScrollFix}
    >
      <ResetPassword onOk={onOk} forgot={data} visible={visible} />
    </Modal>
  );
};
